import { useMemo } from "react";
import { resultsSchema } from "./schema";
import { getRequiredFields } from "components/form/utils";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { CASESTUDY_FIELDS } from "../../form/constants";
import { fetchCaseStudyDataforForm } from "../../form/read";
import { useCreateCasestudy } from "../../create/mutation";
import { useResultsUpdate } from "../update/mutation";

export const useResultsForm = ({ casestudyId }) => {
    const navigate = useNavigate();

    const createCasestudyMutation = useCreateCasestudy();
    const updateResultsMutation = useResultsUpdate();

    const form = useForm({
        resolver: zodResolver(resultsSchema),
        defaultValues: {
            solution_overview: "",
            obstacles: "",
            methodology: "",
            achievements: "",
        },
    });

    const requiredFields = useMemo(
        () => getRequiredFields(resultsSchema),
        [resultsSchema]
    );

    async function handleCreate(context) {
        const values = context.values;
        const response = await createCasestudyMutation.mutateAsync({
            values,
        });
        navigate(`/case-studies/${response.project.id}`);
    }

    async function handleRead(casestudyId) {
        const fields = [...CASESTUDY_FIELDS];

        const response = await fetchCaseStudyDataforForm({ casestudyId, fields });

        const data = {
            ...response,
        };

        return data;
    }

    async function handleUpdate(id, context) {
        const values = context.dirtyValues;
        const response = await updateResultsMutation.mutateAsync({
            caseStudyId: id,
            values,
        });
    }

    return {
        form,
        requiredFields,
        handleCreate,
        handleRead,
        handleUpdate,
    };
};
